<template>
  <MoodSheet
    v-if="checkin.open"
    :key="checkin.checkedDay"
    v-model:open="checkin.open"
    :choices="checkin.choices"
    :question-date="checkin.checkedDay"
    @submitted="checkin.submitted"
  />
</template>
<script setup>
// 1. Import necessary components
import { onMounted, onBeforeUnmount, watch } from 'vue';
import { useDocumentVisibility } from '@vueuse/core';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/core/stores/auth.store';
import { useEmotionCheckinStore } from '@/core/stores/emotion-checkin.store';
import MoodSheet from '@/features/symptoms/components/MoodSheet.vue';
// 2. Use
const checkin = useEmotionCheckinStore();
const auth = useAuthStore();
const route = useRoute();
const visibility = useDocumentVisibility();
// 3. Define a reactive variable
let listener;
let mounted = true;
// 4. Define methods or computed properties if needed
async function check() {
  // Auth screens may be replacing the token; check after returning to patient pages.
  if (auth.isAuthReady && visibility.value === 'visible' && route.meta.moduleTag !== 'auth') {
    await checkin.check();
  }
}
// 5. VueJS Hooks
watch(
  [
    () => route.path,
    () => auth.appOnboardingStatus,
    () => auth.authStateVersion,
    () => auth.isAuthReady,
    visibility,
  ],
  check,
  {
    immediate: true,
  },
);
onMounted(async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  listener = await App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) {
      // Capacitor callbacks are outside Vue's error boundary. RestClient owns feedback.
      void check().catch(() => console.warn('[Emotion check-in] Daily check unavailable'));
    }
  });
  if (!mounted) {
    await listener.remove();
  }
});
onBeforeUnmount(() => {
  mounted = false;
  void listener?.remove();
});
</script>
